function AreaUnit () {
  return (
    <>
      <span>mm</span>
      <sup>2</sup>
    </>
  )
}

export default AreaUnit
